import React from "react";

export const ProductDetailDescriptionFormSkeleton: React.FC = () => {
  return (
    <div className="row tw-h-36 tw-w-full tw-animate-pulse tw-rounded-md"></div>
  );
};
